import TextField from '@mui/material/TextField';

const FromTextField =  ({
  label = "ワークNo",
  helperText = "",
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfWorkNo"
    label={label}
    size="small"
    inputProps={{ maxLength: 8 }}
    onChange={(event: any) => { onChange(event); }}
    error={!!helperText}
    helperText={helperText}
  />
);

export default FromTextField;